import { Link } from "@mui/material";
import { LinkProps } from "@mui/material/Link";
import * as React from "react";

type Props = LinkProps;

const MuiLink: React.FC<Props> = (props) => {
    const { children, href, onClick, ...rest } = props;
    return onClick == null && href == null
        ? <>{children}</>
        : (
            <Link
                href={href || "#"}
                onClick={
                    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        if (href == null) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        if (onClick) onClick(e);
                    }
                }
                {...rest}
            >
                {children}
            </Link>
        );
}

export default MuiLink;
